import React, {useEffect} from 'react';
import { Certification, Download, Info, Phone, Vector } from '../../../ui/icons';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {getMainVideo} from "../../../store/courseSlice";

const SidebarContainer = styled.div`
    width: 30%;
    @media(max-width: 1032px) {
        width: 100%;
    }
`;

const SidebarWrapper = styled.div`
    background: #0A1F44;
    padding: 24px;
    border-radius: 12px;
`;

const BuyButton = styled.button`
    background: #8C1C1C;
    color: #FFF;
    border-radius: 12px;
    padding: 8px 0;
    width: 100%;
    margin-top: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: #8C1C1C12;
    }
`;

const TextWrapper = styled.p`
    gap: 5px;
    display: flex;
    align-items: start;
`;

const TextIcon = styled.span`
    font-size: 15px;
    font-weight: 400;
    color: #1E1E1E;
    opacity: 0.8;
`;

const courseIncludes = [
    { icon: <Download />, text: "6 lessons" },
    { icon: <Vector />, text: "Next lesson: 17.12.2024, 19:00" },
    { icon: <Phone />, text: "Access via mobile devices" },
    { icon: <Certification />, text: "Certificate of completion of the course" }
];

const SideBar = () => {
    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.auth);
    const {mainVideo} = useSelector((state) => state.courses);
    const { token: registerToken } = useSelector(state => state.form);
    useEffect(() => {
        dispatch(getMainVideo())
    },[])
    return (
        <SidebarContainer>
            <SidebarWrapper>
                <p className='font-normal text-[14px] text-[#EAEAEA]'>Full course</p>
                <h2 className='font-semibold text-[36px] flex items-center gap-3 text-white'> 1 800 000 KZT / ${Math.round(mainVideo?.new_price) || 3500}
                    <span className='line-through text-[17px] text-[#EAEAEA] opacity-80 text-sm'>{Math.round(mainVideo?.old_price) || 4200}</span>
                </h2>
                <Link to={token || registerToken ? '/passingcourse/1' : '/signin'}>
                    <BuyButton className='text-base'>Buy</BuyButton>
                </Link>
                <p className='opacity-80 text-[#EAEAEA] pt-2'></p>

                <h3 className='py-3 font-semibold text-white'>Eligibility</h3>
                <TextWrapper>
                    <Info />
                    <TextIcon ><p className='text-[#EAEAEA]'>The course is taught in English. It is the participant’s own responsibility to ensure that their command of the English language is sufficient to attend and successfully complete the course.</p></TextIcon>
                </TextWrapper>
            </SidebarWrapper>
        </SidebarContainer>
    );
};

export default SideBar;
